module.exports = __webpack_public_path__ + "img/prometheus.b72c91c.svg";